import * as go from 'gojs';
import { getImageMobileCone } from 'unitData/Mobile/Cone/getImageMobileCone';
import { alignPorts } from 'unitData/Mobile/Cone/MobileUnitConeCrusherData';
import { MobileUnitConeCrusherTypes } from 'unitData/Mobile/Cone/unitInfoData';
import {
  getImageBinding,
  getMobileInputPort,
  getMobileOutputPort,
  makeNode,
  mobileUnitDefaultOptions,
} from '../../utils';
import type { MobileUnitBaseNodeData } from 'gojs/types';

const MobileConeTemplate = makeNode(
  getImageBinding('', (node: MobileUnitBaseNodeData) =>
    getImageMobileCone(node.model, node.configuration.configKey),
  ),
  [
    getMobileInputPort((node) => {
      if (
        node.model === MobileUnitConeCrusherTypes.UH373 ||
        node.model === MobileUnitConeCrusherTypes.US373
      ) {
        return node.mirrored
          ? new go.Spot(1 - 8 / 12, 0)
          : new go.Spot(8 / 12, 0);
      } else {
        return node.mirrored
          ? new go.Spot(1 - 3 / 12, 0)
          : new go.Spot(3 / 12, 0);
      }
    }),
    getMobileOutputPort(0, alignPorts),
    getMobileOutputPort(1, alignPorts),
    getMobileOutputPort(2, alignPorts),
    getMobileOutputPort(3, alignPorts),
    getMobileOutputPort(4, alignPorts),
  ],
  { ...mobileUnitDefaultOptions },
);

export default MobileConeTemplate;
